import React from "react";

function About() {
    return (
        <section className="about">
            About

            <p className="about-text">
                Mechanical engineering student in the Honors program at Iowa State University.
            </p>
            <p className="about-text">
                Passionate about manufacturing and design, with hands-on experience across CAD modeling,
                DFM/DFA, and prototyping.
            </p>
            <p className="about-text">
                Curious. Dedicated. Team-player.
            </p>
        </section>
    );
}

export default About;
